<template>
  <div>
    <h1>Create new system setting</h1>

    <div class="box">
      <Errors />

      <form class="form" v-on:submit.prevent="createSystemSetting">
        <SystemSettingFields></SystemSettingFields>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create system setting</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SystemSettingFields from "@/components/SystemSettingFields.vue";
import Errors from "@/components/Errors.vue";
import { mapGetters } from "vuex";
export default {
  name: "SystemSettingCreate",
  computed: mapGetters(["getLoadStatus"]),
  data() {
    return {
      setting: {},
      errors: null
    };
  },
  components: {
    SystemSettingFields,
    Errors
  },
  methods: {
    createSystemSetting() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "settings/system", {
        method: "POST",
        body: JSON.stringify(this.setting),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors;
          if (response.success) {
            this.$router.push({
              name: "system-setting-edit",
              params: { id: response.data.id }
            });
            this.$notify({
              type: "success",
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: "error",
              title: response.message
            });
          } else {
            this.$notify({
              type: "error",
              title: response.error
            });
          }
          this.$store.dispatch("setLoadStatus");
        });
    }
  }
};
</script>
